var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-progress-circular',{attrs:{"size":40,"width":3,"color":"pink darken-1","indeterminate":""}}),_c('br'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }